export default class Utils {
    static getErrorMessage(error: any): string {
        if (error.response && error.response.data && error.response.data.error) {
            return error.response.data.error;
        }
        return error.message || 'An unknown error occurred';
    }

    static getRandomString(maxLength=6) {
        // https://gist.github.com/gordonbrander/2230317
        let randomString = '';
    
        for (let i =0; i< 4; i++) {
            randomString += Math.random().toString(36).substr(2, 8);
        }
        if (maxLength) {
            randomString = randomString.substring(0, maxLength);
        }
    
        return randomString;
    }
}